import { Link, useNavigate } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ChangePassword } from "@/pages/admin/ChangePassword";

export const AdminLayout = ({ title, back, actions, children }) => {
  const nav = useNavigate();
  const logout = () => {
    localStorage.removeItem("jt_admin_token");
    nav("/admin/login");
  };
  return (
    <div className="admin min-h-screen bg-neutral-100 text-neutral-900">
      <header className="sticky top-0 z-30 bg-black text-white">
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between gap-3">
          <Link to="/admin" className="admin-brand text-xl" data-testid="admin-home-link">joetanis.com <span className="text-neutral-400 text-sm font-normal">admin</span></Link>
          <div className="flex items-center gap-2">
            <a href="/" target="_blank" rel="noreferrer" className="hidden sm:flex items-center gap-1 text-sm text-neutral-300 hover:text-white px-2" data-testid="admin-view-site">
              View site <ExternalLink size={14} />
            </a>
            <ChangePassword />
            <Button variant="ghost" size="sm" onClick={logout} className="text-neutral-300 hover:text-white hover:bg-white/10" data-testid="admin-logout-button">
              <LogOut size={16} />
            </Button>
          </div>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-5 py-8">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
          <div>
            {back && <Link to={back} className="text-sm text-neutral-500 hover:text-black" data-testid="admin-back-link">← Back</Link>}
            <h1 className="admin-brand text-3xl sm:text-4xl mt-1">{title}</h1>
          </div>
          <div className="flex flex-wrap gap-2">{actions}</div>
        </div>
        {children}
      </div>
    </div>
  );
};
